import { Modal, Button, Table } from 'react-bootstrap'

interface MediaDeleteFormProps {
  onSubmit: () => void
  fetching: boolean
  title: string
  submitButtonText: string
  onClickCancel: () => void
  media: { id: number; name: string }[]
}

export const MediaDeleteForm = ({
  onSubmit,
  fetching,
  title,
  submitButtonText,
  onClickCancel,
  media
}: MediaDeleteFormProps) => (
  <>
    <Modal.Header>
      <Modal.Title>{title}</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <p>以下の媒体を削除します。よろしいですか？</p>
      <Table striped bordered hover size='sm'>
        <thead>
          <tr>
            <td>ID</td>
            <td>名称</td>
          </tr>
        </thead>
        <tbody>
          {media.map(({ id, name }) => (
            <tr key={id}>
              <td>{id}</td>
              <td>{name}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </Modal.Body>
    <Modal.Footer>
      <Button variant='secondary' onClick={onClickCancel}>
        キャンセル
      </Button>
      <Button type='submit' disabled={fetching} onClick={onSubmit}>
        {submitButtonText}
      </Button>
    </Modal.Footer>
  </>
)
